import { Absence } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'
import { ABSENCES_QUERY_KEY, ABSENCES_TODAY_QUERY_KEY, ABSENCES_URL } from './queryConstants'
import dayjs from 'dayjs'
import { getQueryParams } from 'utils/getQueryParams'

type UseAbsencesTodayListProps = {
  users?: [string | undefined]
  absenceType?: string
}

type UseAbsencesTodayListReturn = {
  todayAbsences: Absence[]
  isTodayAbsencesLoading: boolean
}

export const useAbsencesTodayList = ({
  users,
  absenceType,
}: UseAbsencesTodayListProps): UseAbsencesTodayListReturn => {
  const todayAbsencesQueryParams = getQueryParams({
    dateRange: [
      dayjs().startOf('day').toISOString(),
      dayjs().endOf('day').toISOString(),
    ],
    users,
    absenceType,
  })

  const { data: todayAbsencesData, isLoading: isTodayAbsencesLoading } =
    useQuery(
      [ABSENCES_QUERY_KEY,ABSENCES_TODAY_QUERY_KEY, users?.join('-'), absenceType],
      () =>
        getJSON({
          url: `${ABSENCES_URL}?${todayAbsencesQueryParams}`,
          isRota: true,
        }),
      { enabled: true }
    )

  return {
    todayAbsences: todayAbsencesData?.data || [],
    isTodayAbsencesLoading,
  }
}
